import React from 'react'
import HomeBanner from './HomeBanner'
import HomeDeliver from './HomeDeliver'
import HomeAbout from './HomeAbout'
import HomeServices from './HomeServices'
import HomeWorkProcess from './HomeWorkProcess'
import HomePortfolio from './HomePortfolio'
import HomeBeforeAfter from './HomeBeforeAfter'
import HomeStrength from './HomeStrength'
import HomeTestomonials from './HomeTestomonials'
import HomeContact from './HomeContact'
import HomeAccordion from './HomeAccordion'

const Home = () => {
  return (
    <>
    <HomeBanner/>
    <HomeDeliver/>
    <HomeAbout/>
    <HomeServices/>
    <HomeWorkProcess/>
    <HomePortfolio/>
    <HomeBeforeAfter/>
    <HomeStrength/>
    <HomeTestomonials/>
    <HomeContact/>
    <HomeAccordion/>
    </>
  )
}

export default Home